import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => (
  <SectionContainer
    id='life-insurance-faq-online-info'
    backgroundVariant='lightA'
    themeType='lightTheme'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h1'
          nextElement='typography'
          align='left'>
          Life Insurance FAQs
        </Typography>
        <Typography
          component='h2'
          nextElement='typography'
          align='left'>
          Access Online Account Information
        </Typography>
        <Typography nextElement='typography'>
          Northwestern Mutual online account access is available for the following types of
          policies&#47;accounts:
        </Typography>
        <BulletedList
          bulletedListData={[
            { bulletText: 'Life insurance' },
            { bulletText: 'Disability insurance' },
            { bulletText: 'Annuity contracts' },
            { bulletText: 'Variable annuity contracts' },
          ]}
        />
        <Typography
          component='h3'
          nextElement='typography'>
          Register for Online Access to Your Accounts
        </Typography>
        <Typography nextElement='typography'>
          <Link
            id='register-online-access-accounts-link'
            linkUrl='https://plan.northwesternmutual.com/'
            variant='primaryDeemphasize'>
            Register now
          </Link> so you can access your
          accounts at your convenience.
        </Typography>
        <Typography disableBottomPadding>
          You will need to have a product number in hand to register. This includes one of the following: insurance policy number, annuity contract number or insurance service account number.
        </Typography>
      </Col>
    </Row>
  </SectionContainer>
);
